// extracted by mini-css-extract-plugin
export default {"loader":"PageLoading_loader__8-U+C"};